import request from '@/utils/request';

// 性别
export const dictionariesSex = () =>
  request({
    url: '/api/blade-system/dict/dictionary?code=sex',
    method: 'get',
  });

// 户籍性质
export const dictionariesAccountYype = () =>
  request({
    url: '/api/blade-system/dict/dictionary?code=account_type',
    method: 'get',
  });

// 民族
export const dictionariesNationality = () =>
  request({
    url: '/api/blade-system/dict/dictionary?code=nationality',
    method: 'get',
  });

// 学历
export const dictionariesEducation = () =>
  request({
    url: '/api/blade-system/dict/dictionary?code=education',
    method: 'get',
  });

// 地区
export const dictionariesSelect = params =>
  request({
    url: '/api/blade-system/region/select',
    method: 'get',
    params,
  });

// 人员类型
export const dictionariesPolitical = () =>
  request({
    url: '/api/blade-system/dict/dictionary?code=political_status',
    method: 'get',
  });
